import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import ErrorToast from '@/components/toasts/ErrorToast';
import { responseError } from '@/utils/errors';
import actions from '../constants';

export function* datasetCollectionToast({ code, name }) {
  yield call(showToast, <UpdatedToast code={code} name={name} />);
}

export function* addDatasetCollectionErrorToast({ errors }) {
  yield call(showToast, <ErrorsToast operation="actions.add" errors={errors} />);
}

export function* removeDatasetCollectionErrorToast(action) {
  yield call(
    showToast,
    <ErrorToast operation="actions.remove" name={action.name} error={responseError(action).message} />,
  );
}

export default function* datasetCollectionsToasts() {
  yield takeEvery(
    [actions.ADD_DATASET_COLLECTIONS_SUCCESS, actions.REMOVE_DATASET_COLLECTION_SUCCESS],
    datasetCollectionToast,
  );
  yield takeEvery(actions.REMOVE_DATASET_COLLECTION_ERROR, removeDatasetCollectionErrorToast);
  yield takeEvery(actions.ADD_DATASET_COLLECTIONS_ERROR, addDatasetCollectionErrorToast);
}
